import React, { memo } from 'react'

function AppEventsTracker() {
  return (
    <></>
  )
}

export default memo(AppEventsTracker)
